"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.MaskCEP = function (value) {
  value = value.replace(/\D/g, '');
  value = value.substring(0, 8);
  value = value.replace(/(\d{2})(\d)/, '$1.$2');
  value = value.replace(/(\d{3})(\d)/, '$1-$2');
  return value;
};